var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{staticClass:"activity-panel"},[_c('ul',{staticClass:"box"},_vm._l((_vm.t_data),function(item,i){return _c('li',{key:i,staticClass:"content"},[(item.imgUrl)?_c('img',{staticClass:"i",attrs:{"src":item.imgUrl}}):_vm._e()])}),0)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }